import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Compré el Combo 2 y Relaciones Conscientes me ordenó la cabeza. Entendí por qué siempre elegía personas no disponibles.',
  author: 'Valentina M.',
  location: 'Buenos Aires',
  stars: 5
}, {
  text: 'El libro de Límites Emocionales me cambió. Por primera vez pude decirle que no a mi ex sin sentir que era mala persona.',
  author: 'Carolina R.',
  location: 'Medellín',
  stars: 5
}, {
  text: 'Detox Afectivo me ayudó a soltar una relación de 5 años. Lloré, pero también entendí. Gracias.',
  author: 'Martín L.',
  location: 'Santiago',
  stars: 5
}, {
  text: 'Mente Fuerte en el Amor del Combo 3 es oro puro. Dejé de perderme en cada relación nueva.',
  author: 'Luciana G.',
  location: 'Córdoba',
  stars: 5
}, {
  text: 'Pensé que era otro libro de autoayuda vacío. Me equivoqué. Es práctico, directo y me hizo ver cosas que no quería ver.',
  author: 'Diego F.',
  location: 'Lima',
  stars: 4
}];
export function TestimonialsSection() {
  return <section className="py-20 px-4 bg-[#0a0a0e]" data-id="element-156">
      <div className="max-w-6xl mx-auto" data-id="element-157">
        <h2 className="text-3xl font-bold text-center text-white mb-16" data-id="element-158">
          Lo que dicen quienes ya lo leyeron
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-159">
          {testimonials.map((t, i) => <div key={i} className="bg-[#1a1a24] p-6 rounded-xl border border-white/5 hover:border-[#d4a853]/20 transition-colors" data-id="element-160">
              <div className="flex gap-1 mb-4" data-id="element-161">
                {[...Array(5)].map((_, idx) => <Star key={idx} className={`w-4 h-4 ${idx < t.stars ? 'fill-[#d4a853] text-[#d4a853]' : 'text-gray-600'}`} data-id="element-162" />)}
              </div>
              <p className="text-gray-300 mb-6 leading-relaxed" data-id="element-163">"{t.text}"</p>
              <div className="flex items-center gap-3" data-id="element-164">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#d4a853] to-[#8a6d3b] flex items-center justify-center text-black font-bold text-sm" data-id="element-165">
                  {t.author.charAt(0)}
                </div>
                <div data-id="element-166">
                  <p className="text-white font-medium text-sm" data-id="element-167">{t.author}</p>
                  <p className="text-gray-500 text-xs" data-id="element-168">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>

        <p className="text-center text-gray-600 text-xs mt-12" data-id="element-169">
          Testimonios reales de compradores. Resultados pueden variar según cada
          persona.
        </p>
      </div>
    </section>;
}